import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { portfolio as t } from "../Themes"
import { Github, Twitter, Facebook, LinkedIn } from "../AllSvgs"
import { Section, Inner, Label, reveal } from "./ui"

const Center = styled.div`
text-align: center;
display: flex;
flex-direction: column;
align-items: center;
`

const Big = styled(motion.h2)`
font-size: clamp(2.4rem, 7vw, 4.6rem);
margin: 0.6rem 0 1.2rem;
letter-spacing: -0.03em;
`

const Sub = styled(motion.p)`
color: ${t.muted};
max-width: 52ch;
font-size: 1.08rem;
margin-bottom: 2.6rem;
`

const Mail = styled(motion.a)`
font-family: ${t.mono};
font-size: clamp(0.95rem, 2.5vw, 1.15rem);
color: ${t.accent};
border: 1px solid rgba(${t.accentRgba}, 0.45);
padding: 1rem 2rem;
border-radius: 999px;
transition: all 0.25s ease;

&:hover{
    background-color: ${t.accentDim};
    border-color: ${t.accent};
    transform: translateY(-2px);
    box-shadow: 0 14px 40px -16px rgba(${t.accentRgba}, 0.55);
}
`

const Socials = styled.div`
display: flex;
gap: 1.2rem;
margin-top: 2.6rem;

a{
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    border: 1px solid ${t.border};
    transition: all 0.2s ease;
}
a:hover{
    border-color: ${t.accent};
    background-color: ${t.accentDim};
    transform: translateY(-2px);
}
`

const Foot = styled.footer`
text-align: center;
padding: 2.5rem 1.5rem 3rem;
border-top: 1px solid ${t.border};
font-family: ${t.mono};
font-size: 0.8rem;
color: ${t.faint};

span{ color: ${t.muted}; }
`

const Contact = () => {
    const year = 2026
    return (
        <>
            <Section id="contact">
                <Inner>
                    <Center>
                        <Label num="05" style={{ justifyContent: "center" }} {...reveal}>
                            What's next
                        </Label>
                        <Big {...reveal}>Let's build something.</Big>
                        <Sub {...reveal}>
                            I'm open to new opportunities and collaborations — backend,
                            full-stack or telecom platform work. My inbox is always open,
                            so say hi and I'll get back to you.
                        </Sub>
                        <Mail
                            href="mailto:bereketyezelalem@gmail.com"
                            {...reveal}
                        >
                            bereketyezelalem@gmail.com
                        </Mail>
                        <Socials>
                            <a href="https://github.com/bereket-09" target="_blank" rel="noreferrer" aria-label="GitHub">
                                <Github width={20} height={20} fill={t.text} />
                            </a>
                            <a href="https://www.linkedin.com/in/bereket-zelalem/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                                <LinkedIn width={19} height={19} fill={t.text} />
                            </a>
                            <a href="https://twitter.com/ye_zelalem" target="_blank" rel="noreferrer" aria-label="Twitter">
                                <Twitter width={20} height={20} fill={t.text} />
                            </a>
                            <a href="https://facebook.com/bereket.zelalem.2" target="_blank" rel="noreferrer" aria-label="Facebook">
                                <Facebook width={20} height={20} fill={t.text} />
                            </a>
                        </Socials>
                    </Center>
                </Inner>
            </Section>
            <Foot>
                Designed &amp; built by <span>Bereket Zelalem</span> · © {year}
            </Foot>
        </>
    )
}

export default Contact
